// removed by extract-text-webpack-plugin
module.exports = {"block":"header__block-Cc7T8","wrapper":"header__wrapper-NcMKX","content":"header__content-2xRNn blocks__content--MOaB","price":"header__price-RuUkR","order":"header__order-yNQmE","isSticked":"header__isSticked-_Be36"};


//////////////////
// WEBPACK FOOTER
// ./components/order/header/header.css
// module id = 844
// module chunks = 0